import { useState } from "react"
import { useDispatch } from "react-redux"
import { resetFilterOption, updateFilterExclusion, updatePendingFilters } from "../../features/leadTableFiltersSlice"
import './../../css/quilityIcons.css'
import { useSelector } from "react-redux"

/**
 * Component for showing the selected options for a range filter
 *
 * @param {SelectedRangeFilterInfoProps} props
 * @returns {React.JSX.Element}
 */
function SelectedRangeFilterInfo({ title, filter, filterName }) {
    const [hover, setHover] = useState(false)
    const dispatch = useDispatch()
    const {labels} = useSelector(state => state.leadTableFilter)

    const handleClickClose = () => {
        dispatch(resetFilterOption({field: filter.field}))
        dispatch(updatePendingFilters(true))
    }

    const handleClickHover = () => {
        dispatch(updateFilterExclusion({ field: filter.field }))
        dispatch(updatePendingFilters(true))
    }

    return (
        <div onMouseEnter={_ => setTimeout(() => setHover(true), 250)} onMouseLeave={_ => setTimeout(() => setHover(false), 250)} style={{ minHeight: 28, paddingTop: 6, paddingBottom: 6, paddingLeft: 8, paddingRight: 4, background: '#F8F8F8', borderRadius: 6, outline: '1px #E4E4E4 solid', outlineOffset: '-1px', justifyContent: 'center', alignItems: 'flex-start', gap:4, display: 'flex', flexDirection: 'column' }}>
            <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex' }}>
                <div style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', textAlign: 'center', color: '#707070', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '600', wordWrap: 'break-word' }}>{title}:</div>
                {filter.excluded && (
                    <div style={{ width: 12, height: 12, position: 'relative' }}>
                        <div className="math-minus-circle" style={{ width: 12, height: 12, left: 1, top: 1, position: 'absolute' }} />
                    </div>
                )}
                <div style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', textAlign: 'center', color: filter.excluded ? '#DE3F35' : '#707070', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}> {labels[filter.field] ?? `${filter.start}-${filter.end}`}</div>
                <div onClick={ _ => handleClickClose()} style={{ cursor:'pointer', width: 10, height: 10, position: 'relative' }}>
                    <div className="x-close" style={{ width: 10, height: 10, left: 1, top: 1, position: 'absolute' }} />
                </div>
            </div>
            {hover && (
                <div onClick={_ => handleClickHover()} style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex', cursor: "pointer" }}>
                    <div style={{ height: 10, textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', color: filter.excluded?'#005851':"#707070", fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', textDecoration: 'underline' }}>Exclude {title}</div>
                </div>
            )}
        </div>
    )
}
export default SelectedRangeFilterInfo